module.exports = __webpack_public_path__ + "static/media/vanityCupboards.66838651.jpg";